import { getLenis } from './lenis';

// One place to subscribe to scroll. Lenis emits its own event while it owns the
// scroll; without it (reduced motion) we fall back to a passive listener. No
// module ever runs its own requestAnimationFrame loop.
export function onScroll(handler: () => void): void {
  const lenis = getLenis();

  if (lenis) {
    lenis.on('scroll', handler);
  } else {
    window.addEventListener('scroll', handler, { passive: true });
  }

  window.addEventListener('resize', handler, { passive: true });
  handler();
}

// How far the document is scrolled, 0…1.
export function scrollProgress(): number {
  const el = document.documentElement;
  const max = el.scrollHeight - el.clientHeight;
  return max > 0 ? Math.min(1, Math.max(0, el.scrollTop / max)) : 0;
}
